import React from 'react'
import Modal from '@mui/material/Modal'
import styled from '@emotion/styled'
import LoaderImg from '../../Assets/svg/loader.svg'
import { useStore } from '../../Store'

const LoaderContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center',
  position: 'relative',
  height: '100vh',
  width: '100vw',
}))

const Message = styled('Typography')(({ theme }) => ({
  color: theme.palette.text.white || '#FFF',
  marginTop: '1rem',
  fontSize: '2rem',
}))

function Loading() {
  const { loading } = useStore((state) => ({
    loading: state.loading,
  }))

  return (
    <Modal open={loading} style={{ backgroundColor: '#' }}>
      <LoaderContainer>
        <img alt="loading" src={LoaderImg} style={{ width: '50%' }} />
        <Message variant="h2">
          {typeof loading === 'string' ? loading : 'Loading ...'}
        </Message>
      </LoaderContainer>
    </Modal>
  )
}

export default Loading
